import { authHeader } from "~/helpers/authHeader";

export const getAllNoticeboard = (page = 1) => {

    let pageParam = `?page=${page}`;

    return (dispatch) => {

        return fetch('/api/notifications/' + pageParam, {
            method: 'GET',
            credentials: 'include',
            headers: authHeader()
        })
            .then((res) => res.text())
            .then((text) => text.length ? JSON.parse(text) : [])
            .then((data) => {
                dispatch({
                    type: 'homepage/SET_NOTICEBOARD',
                    payload: data,
                });
            });
    };
};


export const setNoteAsRead = (id) => {

    return (dispatch) => {

        return fetch('/api/notifications/' + id, {
            method: 'POST',
            credentials: 'include',
            headers: authHeader()
        }).then((response) => {

            if (response.ok) {
                return dispatch(getAllNoticeboard())
                    .then(() => {
                        return true;
                    });
            };

            if (response.status === 422) {
                return response.json()
            };

            throw Error('Unknown error!');
        });
    };
};

export const markAllNotesAsRead = (id) => {

    return (dispatch) => {

        return fetch('/api/notifications/user/read-all', {
            method: 'POST',
            credentials: 'include',
            headers: authHeader()
        }).then((response) => {

            if (response.ok) {
                return dispatch(getAllNoticeboard())
                    .then(() => {
                        return true;
                    });
            };

            if (response.status === 422) {
                return response.json()
            };

            throw Error('Unknown error!');
        });
    };
};

export const logoutUser = () => {

    return (dispatch) => {
        fetch('/api/users/logout', {
            method: 'POST',
            credentials: 'include',
            headers: authHeader()
        })
            .then(() => {
                localStorage.removeItem('token');
                dispatch({
                    type: 'user/SET_USER',
                    payload: null,
                })
            })
    }
}